import { render, staticRenderFns } from "./product-form-component.vue?vue&type=template&id=3c0bc87e&scoped=true"
import script from "./product-form-component.vue?vue&type=script&lang=js"
export * from "./product-form-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bc87e",
  null
  
)

export default component.exports